<!-- 
  This is a wrapper component that handles the styling and layout of a single
  panel element in the workspace. We wrap all of our editors in this component
-->

<template>
  <div class="panel">
    <span class="panel-label">
      {{ label }}
    </span>
    <Scrollable
      class-name="panel-content"
      auto-hide="move"
      ref="contentContainer"
      @overflowAmountChanged="$emit('overflowAmountChanged', $event)"
      overflow-x="hidden"
    >
      <slot />
    </Scrollable>
    <v-fade-transition>
      <v-btn
        :class="step === 2 ? 'arrowButton' : 'arrowButton step2'"
        fab
        :color="arrowColor"
        @click="$emit('arrowClick')"
        small
        :disabled="!validClaims"
        v-if="arrowButton"
        elevation="0"
      >
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-fade-transition>
  </div>
</template>

<script>
import Scrollable from '../global/Scrollable';
import { messages as M } from '@/data/constants';
import { mapGetters, mapMutations, mapState } from 'vuex';
import {
  GENERATE_BUTTON_MESSAGE,
  REGENERATE_BUTTON_MESSAGE,
} from '@/data/constants/constantsTooltip';

export default {
  name: 'Panel',
  components: {
    Scrollable,
  },
  props: {
    label: String,
    arrowButton: Boolean,
  },
  data() {
    return {
      GENERATE_BUTTON_MESSAGE,
    };
  },

  mounted() {
    if (this.label === M.GEN_DESCRIPTION) {
      const scrollInstance = this.$refs.contentContainer.$refs.osRef.osInstance();
      this.setSpecScrollInstance(scrollInstance);
    }

    if (this.label === `${M.GEN_DIAGRAM}s`) {
      const scrollInstance = this.$refs.contentContainer.$refs.osRef.osInstance();
      this.setFigureScrollInstance(scrollInstance);
    }
  },

  computed: {
    ...mapState('draft', {
      loading: (state) => state.loading,
      inserting: (state) => state.insertingDocData,
      step: (state) => state.step,
    }),
    ...mapGetters('draft', ['outlineChanged', 'claimsChanged', 'validClaims', 'initialOutline']),
    ...mapState('tooltip', ['tooltip']),
    arrowColor() {
      return (this.outlineChanged || (this.claimsChanged && this.validClaims)) &&
        !this.loading &&
        !this.inserting
        ? 'primary'
        : 'lightGray';
    },

    tooltipMessage() {
      return this.step === 1 ? GENERATE_BUTTON_MESSAGE : REGENERATE_BUTTON_MESSAGE;
    },
  },

  methods: {
    ...mapMutations({
      setSpecScrollInstance: 'draft/setSpecScrollInstance',
      setFigureScrollInstance: 'draft/setFigureScrollInstance',
    }),
  },
};
</script>

<style lang="scss" scoped>
$panel-height: 100%;

.panel-content {
  width: 100%;
  height: calc(100% - 30px) !important;
  color: $panel-text-color !important;
}

.yeet {
  height: 100%;
  width: 100%;
}

.panel {
  .arrowButton {
    position: absolute;
    z-index: 100;
    background-color: $light-gray;
    top: calc(50%);
    right: -30px;
    transition: background-color 0.3s;

    &.step2 {
      right: -70px;
    }

    &.v-btn.v-btn--disabled {
      background-color: $light-gray !important;
    }

    &.changed {
      background-color: $primary;
      color: white !important;
    }
  }
}

.panel-label {
  display: block;
  height: 30px;
  line-height: 30px;
  font-size: 15px;
  padding-left: 8px;
  width: fit-content;
}
</style>
